import { getNewReplies } from "./reducer"; // import async thunk from reducer

export const fetchReplies = () => {
    return getNewReplies(); // Dispatch async thunk instead of traditional actions
};

